import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ControlProvider } from "./modules/control";
import { Application } from "./application";
import { store } from "./store";
import type { Config } from "./modules/control";
import type { ChatChildren } from "./modules/chat";

type Props = {
  config: Config;
  dataTestId?: string;
  className?: string;
  children: ChatChildren;
};

export const WebChat = ({
  dataTestId = "chat-icon-container",
  config,
  className = "",
  children,
}: Props) => (
  <ReduxProvider store={store}>
    <ControlProvider config={config}>
      <Application dataTestId={dataTestId} className={className}>
        {children}
      </Application>
    </ControlProvider>
  </ReduxProvider>
);

export type { Config };
